import { GuiBase } from "../GuiBase";

export class GuiLoginRecover extends GuiBase {

    constructor() {
        super("LoginRecover");
    }

}
